'use client'

import { CubeIcon } from '@radix-ui/react-icons'
import {
  ArrowLeftRightIcon,
  BookIcon,
  BotIcon,
  Building,
  ClockIcon,
  CpuIcon,
  Gamepad2Icon,
  HeartPulseIcon,
  HomeIcon,
  ImageIcon,
  InfoIcon,
  RadioIcon,
  ShoppingCartIcon,
  SproutIcon,
  StarIcon,
  StoreIcon,
  TrophyIcon,
  WalletIcon
} from 'lucide-react'

import {
  FacebookIcon,
  TelegramIcon,
  TikTokIcon,
  XIcon,
  YouTubeIcon
} from '@/components/ui/brand-icons'
import { Routes } from '@/constants/routes'
import { msg } from '@lingui/core/macro'

export const MENU_LINKS = [
  {
    title: msg`Products`,
    items: [
      {
        title: msg`PIONE Wallet`,
        description: msg`Secure, fast, and private digital asset management.`,
        icon: <WalletIcon className='size-5 shrink-0' />,
        href: Routes.Wallet,
        external: true
      },
      {
        title: msg`PIONE Farm`,
        description: msg`Trace agricultural product origins, ensuring transparency.`,
        icon: <SproutIcon className='size-5 shrink-0' />,
        href: Routes.Farm,
        external: true
      },
      {
        title: msg`PIONE Care`,
        description: msg`Transparent and modern medical record management.`,
        icon: <HeartPulseIcon className='size-5 shrink-0' />,
        href: Routes.Care,
        external: true
      },
      {
        title: msg`PIONE House`,
        description: msg`Real estate identification and transparent transactions.`,
        icon: <HomeIcon className='size-5 shrink-0' />,
        href: Routes.House,
        external: true
      },
      {
        title: msg`PIONE Exchange`,
        description: msg`Secure DEX trading platform with AI integration.`,
        icon: <CubeIcon className='size-5 shrink-0' />,
        href: Routes.Exchange,
        external: true
      },
      {
        title: msg`PIONE Mart`,
        description: msg`Decentralized e-commerce, convenient shopping.`,
        icon: <ShoppingCartIcon className='size-5 shrink-0' />,
        href: Routes.Mart,
        external: true
      },
      {
        title: msg`PIONE Swap`,
        description: msg`Fast, cost-effective cross-chain bridge transactions.`,
        icon: <ArrowLeftRightIcon className='size-5 shrink-0' />,
        href: Routes.Swap,
        external: true
      },
      {
        title: msg`PIONE NFT`,
        description: msg`Organization-identified NFTs, created by PoAI.`,
        icon: <ImageIcon className='size-5 shrink-0' />,
        href: Routes.NFT,
        external: true
      },
      {
        title: msg`PIONE Games`,
        description: msg`Web3 games innovating player experiences.`,
        href: '#',
        icon: <Gamepad2Icon className='size-5 shrink-0' />
      },
      {
        title: msg`PIONE Star`,
        description: msg`Transparent and reliable livestream social network.`,
        href: '#',
        icon: <RadioIcon className='size-5 shrink-0' />
      },
      {
        title: msg`PIONE Node`,
        description: msg`AI-integrated, quantum technology coin mining machine.`,
        href: '#',
        icon: <CpuIcon className='size-5 shrink-0' />
      },

      {
        title: msg`PIONE AI & Bot`,
        description: msg`Automated trading with artificial intelligence.`,
        href: '#',
        icon: <BotIcon className='size-5 shrink-0' />
      },
      {
        title: msg`PIONE Smart`,
        description: msg`Knowledge hub for AI, Metaverse, and new technologies.`,
        href: '#',
        icon: <BookIcon className='size-5 shrink-0' />
      },
      {
        title: msg`PIONE Dapps Store`,
        description: msg`Collection of decentralized Web3 Dapps.`,
        href: '#',
        icon: <StoreIcon className='size-5 shrink-0' />
      }
    ]
  },
  {
    title: msg`Solutions`,
    href: Routes.Solutions,
    external: false
  },
  {
    title: msg`About Pione Group`,
    items: [
      {
        title: msg`Overview`,
        description: msg`Introduction to Pione Group's mission and vision.`,
        icon: <InfoIcon className='size-5 shrink-0' />,
        href: Routes.Overview,
        external: false
      },
      // {
      //   title: msg`Team`,
      //   description: msg`Meet our team of experts.`,
      //   icon: <UsersIcon className='size-5 shrink-0' />,
      //   href: Routes.Team,
      //   external: false
      // },
      {
        title: msg`Organization & Operations`,
        description: msg`Explore our organizational structure and operational workflows.`,
        icon: <Building className='size-5 shrink-0' />,
        href: Routes.OrgOps,
        external: false
      },
      {
        title: msg`Our Journey`,
        description: msg`Pione Group's development journey and milestones.`,
        icon: <ClockIcon className='size-5 shrink-0' />,
        href: Routes.OurJourney,
        external: false
      },
      {
        title: msg`Why Choose Pione Group`,
        description: msg`Reasons why Pione Group is the top choice.`,
        icon: <StarIcon className='size-5 shrink-0' />,
        href: Routes.WhyChoose,
        external: false
      },
      {
        title: msg`Awards`,
        description: msg`Achievements and awards of Pione Group.`,
        icon: <TrophyIcon className='size-5 shrink-0' />,
        href: Routes.Awards,
        external: false
      }
    ]
  },
  {
    title: msg`News`,
    href: Routes.Blog,
    external: false
  }
]

export const FOOTER_LINKS = [
  {
    title: msg`Products`,
    links: [
      { name: msg`PIONE Wallet`, href: Routes.Wallet, external: true },
      { name: msg`PIONE Farm`, href: Routes.Farm, external: true },
      { name: msg`PIONE Care`, href: Routes.Care, external: true },
      { name: msg`PIONE House`, href: Routes.House, external: true },
      { name: msg`PIONE Exchange`, href: Routes.Exchange, external: true },
      { name: msg`PIONE Mart`, href: Routes.Mart, external: true },
      { name: msg`PIONE Swap`, href: Routes.Swap, external: true },
      { name: msg`PIONE AI & Bot`, href: Routes.AI, external: true },
      { name: msg`PIONE NFT`, href: Routes.NFT, external: true }
    ]
  },
  {
    title: msg`Resources`,
    links: [{ name: msg`Contact`, href: Routes.Contact, external: false }]
  },
  {
    title: msg`About`,
    links: [{ name: msg`Blog`, href: Routes.Blog, external: false }]
  },
  {
    title: msg`Legal`,
    links: [
      { name: msg`Terms of Use`, href: Routes.TermsOfUse, external: false },
      { name: msg`Privacy Policy`, href: Routes.PrivacyPolicy, external: false },
      { name: msg`Cookie Policy`, href: Routes.CookiePolicy, external: false }
    ]
  }
]

export const SOCIAL_LINKS = [
  {
    name: msg`X (formerly Twitter)`,
    href: 'https://x.com/pione_chain',
    icon: <XIcon className='size-4 shrink-0' />
  },
  {
    name: msg`Facebook`,
    href: 'https://www.facebook.com/pionechain',
    icon: <FacebookIcon className='size-4 shrink-0' />
  },
  {
    name: msg`YouTube`,
    href: 'https://www.youtube.com/@pione_chain',
    icon: <YouTubeIcon className='size-4 shrink-0' />
  },
  {
    name: msg`TikTok`,
    href: 'https://www.tiktok.com/@pione_chain',
    icon: <TikTokIcon className='size-4 shrink-0' />
  },
  {
    name: msg`Telegram`,
    href: 'https://t.me/pionechain',
    icon: <TelegramIcon className='size-4 shrink-0' />
  }
]
